"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var token_1 = __importDefault(require("./token"));
var defaultOptions = {
    key: 'auth-client-token',
    logger: console,
};
exports.getTokenFromStorage = function (options) {
    var o = __assign(__assign({}, defaultOptions), options);
    try {
        var stored = localStorage.getItem(o.key);
        if (!stored) {
            return;
        }
        var tokenish = JSON.parse(stored);
        var token = new token_1.default(tokenish);
        return token;
    }
    catch (e) {
        o.logger.error("Token could not be retrieved: " + e.message);
    }
};
exports.setTokenInStorage = function (token, options) {
    if (!token) {
        return;
    }
    var o = __assign(__assign({}, defaultOptions), options);
    try {
        var serialized = JSON.stringify(token);
        localStorage.setItem(o.key, serialized);
    }
    catch (e) {
        o.logger.error("Token could not be stored: " + e.message);
    }
};
exports.removeTokenFromStorage = function (options) {
    var o = __assign(__assign({}, defaultOptions), options);
    try {
        localStorage.removeItem(o.key);
    }
    catch (e) {
        o.logger.error("Token could not be removed: " + e.message);
    }
};
//# sourceMappingURL=store.js.map